// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { getPlatformDetailsSelector } from '../../../platform/platformSelector';

// Components
import CardClipperTiptapContents from './CardClipperTiptapContents';

// Types
import { CardClipperProps } from './cardClipperTypes';
import { DeviceFormFactor, MilanoteApplicationMode } from '../../../../common/platform/platformTypes';

const CardClipper = (props: CardClipperProps) => {
    const { isEditing, isClipping, isClipCopy, isClipDragging, clippedText, elementId, getContextZoomScale } = props;

    const platformDetails = useSelector(getPlatformDetailsSelector);

    if (platformDetails.appMode !== MilanoteApplicationMode.desktop) return null;
    if (platformDetails.formFactor === DeviceFormFactor.phone) return null;

    if (!isClipping && !isEditing) return null;

    return (
        <CardClipperTiptapContents
            getContextZoomScale={getContextZoomScale}
            isClipping={isClipping}
            isClipCopy={isClipCopy}
            isClipDragging={isClipDragging}
            clippedText={clippedText}
            elementId={elementId}
        />
    );
};

export default CardClipper;
